import React, { useState, useEffect, Fragment } from 'react'
import { ReportLayout } from "./../../components"
import { Tabs, Tab, makeStyles, TableCell, Box } from "@material-ui/core"
import { TablePanel } from "./../../components"
import { TopManager } from "./../../components/TopManager"
import { GraphicPanel } from "./../../components"
import { useSelector, useDispatch } from "react-redux";
import { tableCss } from './../../components/Tables/TableCss';
import { useTranslation } from 'react-i18next';
import { reportActions } from "./../../actions"

const useStyles = makeStyles((theme) => ({
  tab: {
    width: "50%",
    maxWidth: "unset",
    backgroundColor: theme.palette.neutrals.high.main,
    border: "1px solid theme.palette.neutrals.high.medium",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  buttonChart: {
    marginRight: 16
  },
  chartBox: {
    padding: "0 120px"
  }
}));

export const ReportManager = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = useState(0);
  const { report, chart, tab } = useSelector(state => state.report)
  const tableClasses = tableCss();
  const { t } = useTranslation();

  const tableInfo = {
    columns: [
      { id: 'manager', label: t('gestor') },
      { id: 'email', label: t('email') },
      { id: 'businessUnit', label: t('unidade_de_negocio') },
      { id: 'local', label: t('local') },
      { id: 'occupationArea', label: t('area_de_atuacao') },
    ],
    data: report.map(item => (
      <Fragment>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.name}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.email}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.bul.businessUnit?.name}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.bul.local?.name}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.bul.occupationArea?.name}</TableCell>
      </Fragment>
    )),
  };

  useEffect(() => {
    return () => {
      dispatch(reportActions.clearAll())
    };
  }, [dispatch]);

  function handleChangeTab(index) {
    dispatch(reportActions.changeTab(index === 0 ? "table" : "graph"));
    setTabIndex(index);
  };

  return (
    <ReportLayout title={t('lista_de_gestores')}>
      <Tabs value={tabIndex} onChange={(e, value) => handleChangeTab(value)} aria-label="Tabs de grafico e tabela" indicatorColor="primary">
        <Tab className={classes.tab} label={t('tabela')} aria-controls="Panel tabela" />
        <Tab className={classes.tab} label={t('grafico')} aria-controls="Panel grafico" />
      </Tabs>

      {tab === "table" && (
        <TablePanel tableInfo={tableInfo} />
      )}

      {tab === "graph" && (
        <GraphicPanel>
            <Box className={classes.chartBox}>
                {chart.sort((a, b) => b.count - a.count).map((item, index) => (
                <TopManager
                    key={index}
                    pointsCalc={item.count}
                    {...item}
                />
                ))}
            </Box>
        </GraphicPanel>
      )}
    </ReportLayout>
  )
};
